import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, Inject, Output } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { DOCUMENT } from '@angular/common';

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoPieChartAdaptiveLayoutComponent = /*#__PURE__*/(() => {
  class DxoPieChartAdaptiveLayoutComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get keepLabels() {
      return this._getOption('keepLabels');
    }
    set keepLabels(value) {
      this._setOption('keepLabels', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'adaptiveLayout';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartAdaptiveLayoutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartAdaptiveLayoutComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartAdaptiveLayoutComponent,
      selectors: [["dxo-pie-chart-adaptive-layout"]],
      inputs: {
        height: "height",
        keepLabels: "keepLabels",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartAdaptiveLayoutComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartAdaptiveLayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartAdaptiveLayoutModule = /*#__PURE__*/(() => {
  class DxoPieChartAdaptiveLayoutModule {
    /** @nocollapse */static ɵfac = function DxoPieChartAdaptiveLayoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartAdaptiveLayoutModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartAdaptiveLayoutModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartAdaptiveLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartAnimationComponent = /*#__PURE__*/(() => {
  class DxoPieChartAnimationComponent extends NestedOption {
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get maxPointCountSupported() {
      return this._getOption('maxPointCountSupported');
    }
    set maxPointCountSupported(value) {
      this._setOption('maxPointCountSupported', value);
    }
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartAnimationComponent,
      selectors: [["dxo-pie-chart-animation"]],
      inputs: {
        duration: "duration",
        easing: "easing",
        enabled: "enabled",
        maxPointCountSupported: "maxPointCountSupported"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartAnimationComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartAnimationModule = /*#__PURE__*/(() => {
  class DxoPieChartAnimationModule {
    /** @nocollapse */static ɵfac = function DxoPieChartAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartAnnotationBorderComponent = /*#__PURE__*/(() => {
  class DxoPieChartAnnotationBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartAnnotationBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartAnnotationBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartAnnotationBorderComponent,
      selectors: [["dxo-pie-chart-annotation-border"]],
      inputs: {
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartAnnotationBorderComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartAnnotationBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartAnnotationBorderModule = /*#__PURE__*/(() => {
  class DxoPieChartAnnotationBorderModule {
    /** @nocollapse */static ɵfac = function DxoPieChartAnnotationBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartAnnotationBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartAnnotationBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartAnnotationBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiPieChartAnnotationComponent = /*#__PURE__*/(() => {
  class DxiPieChartAnnotationComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get allowDragging() {
      return this._getOption('allowDragging');
    }
    set allowDragging(value) {
      this._setOption('allowDragging', value);
    }
    get argument() {
      return this._getOption('argument');
    }
    set argument(value) {
      this._setOption('argument', value);
    }
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get arrowWidth() {
      return this._getOption('arrowWidth');
    }
    set arrowWidth(value) {
      this._setOption('arrowWidth', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get description() {
      return this._getOption('description');
    }
    set description(value) {
      this._setOption('description', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get series() {
      return this._getOption('series');
    }
    set series(value) {
      this._setOption('series', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get tooltipEnabled() {
      return this._getOption('tooltipEnabled');
    }
    set tooltipEnabled(value) {
      this._setOption('tooltipEnabled', value);
    }
    get tooltipTemplate() {
      return this._getOption('tooltipTemplate');
    }
    set tooltipTemplate(value) {
      this._setOption('tooltipTemplate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'annotations';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiPieChartAnnotationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPieChartAnnotationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiPieChartAnnotationComponent,
      selectors: [["dxi-pie-chart-annotation"]],
      inputs: {
        allowDragging: "allowDragging",
        argument: "argument",
        arrowLength: "arrowLength",
        arrowWidth: "arrowWidth",
        border: "border",
        color: "color",
        customizeTooltip: "customizeTooltip",
        data: "data",
        description: "description",
        font: "font",
        height: "height",
        image: "image",
        location: "location",
        name: "name",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        series: "series",
        shadow: "shadow",
        template: "template",
        text: "text",
        textOverflow: "textOverflow",
        tooltipEnabled: "tooltipEnabled",
        tooltipTemplate: "tooltipTemplate",
        type: "type",
        width: "width",
        wordWrap: "wordWrap",
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiPieChartAnnotationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiPieChartAnnotationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiPieChartAnnotationModule = /*#__PURE__*/(() => {
  class DxiPieChartAnnotationModule {
    /** @nocollapse */static ɵfac = function DxiPieChartAnnotationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPieChartAnnotationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiPieChartAnnotationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiPieChartAnnotationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartArgumentFormatComponent = /*#__PURE__*/(() => {
  class DxoPieChartArgumentFormatComponent extends NestedOption {
    get currency() {
      return this._getOption('currency');
    }
    set currency(value) {
      this._setOption('currency', value);
    }
    get formatter() {
      return this._getOption('formatter');
    }
    set formatter(value) {
      this._setOption('formatter', value);
    }
    get parser() {
      return this._getOption('parser');
    }
    set parser(value) {
      this._setOption('parser', value);
    }
    get precision() {
      return this._getOption('precision');
    }
    set precision(value) {
      this._setOption('precision', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useCurrencyAccountingStyle() {
      return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value) {
      this._setOption('useCurrencyAccountingStyle', value);
    }
    get _optionPath() {
      return 'argumentFormat';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartArgumentFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartArgumentFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartArgumentFormatComponent,
      selectors: [["dxo-pie-chart-argument-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartArgumentFormatComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartArgumentFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartArgumentFormatModule = /*#__PURE__*/(() => {
  class DxoPieChartArgumentFormatModule {
    /** @nocollapse */static ɵfac = function DxoPieChartArgumentFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartArgumentFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartArgumentFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartArgumentFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartBorderComponent = /*#__PURE__*/(() => {
  class DxoPieChartBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartBorderComponent,
      selectors: [["dxo-pie-chart-border"]],
      inputs: {
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartBorderComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartBorderModule = /*#__PURE__*/(() => {
  class DxoPieChartBorderModule {
    /** @nocollapse */static ɵfac = function DxoPieChartBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartColorComponent = /*#__PURE__*/(() => {
  class DxoPieChartColorComponent extends NestedOption {
    get base() {
      return this._getOption('base');
    }
    set base(value) {
      this._setOption('base', value);
    }
    get fillId() {
      return this._getOption('fillId');
    }
    set fillId(value) {
      this._setOption('fillId', value);
    }
    get _optionPath() {
      return 'color';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartColorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartColorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartColorComponent,
      selectors: [["dxo-pie-chart-color"]],
      inputs: {
        base: "base",
        fillId: "fillId"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartColorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartColorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartColorModule = /*#__PURE__*/(() => {
  class DxoPieChartColorModule {
    /** @nocollapse */static ɵfac = function DxoPieChartColorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartColorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartColorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartColorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartCommonAnnotationSettingsComponent = /*#__PURE__*/(() => {
  class DxoPieChartCommonAnnotationSettingsComponent extends NestedOption {
    renderer;
    document;
    element;
    get allowDragging() {
      return this._getOption('allowDragging');
    }
    set allowDragging(value) {
      this._setOption('allowDragging', value);
    }
    get argument() {
      return this._getOption('argument');
    }
    set argument(value) {
      this._setOption('argument', value);
    }
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get arrowWidth() {
      return this._getOption('arrowWidth');
    }
    set arrowWidth(value) {
      this._setOption('arrowWidth', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get description() {
      return this._getOption('description');
    }
    set description(value) {
      this._setOption('description', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get series() {
      return this._getOption('series');
    }
    set series(value) {
      this._setOption('series', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get tooltipEnabled() {
      return this._getOption('tooltipEnabled');
    }
    set tooltipEnabled(value) {
      this._setOption('tooltipEnabled', value);
    }
    get tooltipTemplate() {
      return this._getOption('tooltipTemplate');
    }
    set tooltipTemplate(value) {
      this._setOption('tooltipTemplate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'commonAnnotationSettings';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartCommonAnnotationSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartCommonAnnotationSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartCommonAnnotationSettingsComponent,
      selectors: [["dxo-pie-chart-common-annotation-settings"]],
      inputs: {
        allowDragging: "allowDragging",
        argument: "argument",
        arrowLength: "arrowLength",
        arrowWidth: "arrowWidth",
        border: "border",
        color: "color",
        customizeTooltip: "customizeTooltip",
        data: "data",
        description: "description",
        font: "font",
        height: "height",
        image: "image",
        location: "location",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        series: "series",
        shadow: "shadow",
        template: "template",
        text: "text",
        textOverflow: "textOverflow",
        tooltipEnabled: "tooltipEnabled",
        tooltipTemplate: "tooltipTemplate",
        type: "type",
        width: "width",
        wordWrap: "wordWrap",
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoPieChartCommonAnnotationSettingsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoPieChartCommonAnnotationSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartCommonAnnotationSettingsModule = /*#__PURE__*/(() => {
  class DxoPieChartCommonAnnotationSettingsModule {
    /** @nocollapse */static ɵfac = function DxoPieChartCommonAnnotationSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartCommonAnnotationSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartCommonAnnotationSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartCommonAnnotationSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartCommonSeriesSettingsComponent = /*#__PURE__*/(() => {
  class DxoPieChartCommonSeriesSettingsComponent extends NestedOption {
    get argumentField() {
      return this._getOption('argumentField');
    }
    set argumentField(value) {
      this._setOption('argumentField', value);
    }
    get argumentType() {
      return this._getOption('argumentType');
    }
    set argumentType(value) {
      this._setOption('argumentType', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get maxLabelCount() {
      return this._getOption('maxLabelCount');
    }
    set maxLabelCount(value) {
      this._setOption('maxLabelCount', value);
    }
    get minSegmentSize() {
      return this._getOption('minSegmentSize');
    }
    set minSegmentSize(value) {
      this._setOption('minSegmentSize', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get smallValuesGrouping() {
      return this._getOption('smallValuesGrouping');
    }
    set smallValuesGrouping(value) {
      this._setOption('smallValuesGrouping', value);
    }
    get tagField() {
      return this._getOption('tagField');
    }
    set tagField(value) {
      this._setOption('tagField', value);
    }
    get valueField() {
      return this._getOption('valueField');
    }
    set valueField(value) {
      this._setOption('valueField', value);
    }
    get _optionPath() {
      return 'commonSeriesSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartCommonSeriesSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartCommonSeriesSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartCommonSeriesSettingsComponent,
      selectors: [["dxo-pie-chart-common-series-settings"]],
      inputs: {
        argumentField: "argumentField",
        argumentType: "argumentType",
        border: "border",
        color: "color",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        label: "label",
        maxLabelCount: "maxLabelCount",
        minSegmentSize: "minSegmentSize",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        smallValuesGrouping: "smallValuesGrouping",
        tagField: "tagField",
        valueField: "valueField"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartCommonSeriesSettingsComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartCommonSeriesSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartCommonSeriesSettingsModule = /*#__PURE__*/(() => {
  class DxoPieChartCommonSeriesSettingsModule {
    /** @nocollapse */static ɵfac = function DxoPieChartCommonSeriesSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartCommonSeriesSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartCommonSeriesSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartCommonSeriesSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartConnectorComponent = /*#__PURE__*/(() => {
  class DxoPieChartConnectorComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'connector';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartConnectorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartConnectorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartConnectorComponent,
      selectors: [["dxo-pie-chart-connector"]],
      inputs: {
        color: "color",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartConnectorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartConnectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartConnectorModule = /*#__PURE__*/(() => {
  class DxoPieChartConnectorModule {
    /** @nocollapse */static ɵfac = function DxoPieChartConnectorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartConnectorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartConnectorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartConnectorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartExportComponent = /*#__PURE__*/(() => {
  class DxoPieChartExportComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get fileName() {
      return this._getOption('fileName');
    }
    set fileName(value) {
      this._setOption('fileName', value);
    }
    get formats() {
      return this._getOption('formats');
    }
    set formats(value) {
      this._setOption('formats', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get printingEnabled() {
      return this._getOption('printingEnabled');
    }
    set printingEnabled(value) {
      this._setOption('printingEnabled', value);
    }
    get svgToCanvas() {
      return this._getOption('svgToCanvas');
    }
    set svgToCanvas(value) {
      this._setOption('svgToCanvas', value);
    }
    get _optionPath() {
      return 'export';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartExportComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartExportComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartExportComponent,
      selectors: [["dxo-pie-chart-export"]],
      inputs: {
        backgroundColor: "backgroundColor",
        enabled: "enabled",
        fileName: "fileName",
        formats: "formats",
        margin: "margin",
        printingEnabled: "printingEnabled",
        svgToCanvas: "svgToCanvas"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartExportComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartExportComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartExportModule = /*#__PURE__*/(() => {
  class DxoPieChartExportModule {
    /** @nocollapse */static ɵfac = function DxoPieChartExportModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartExportModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartExportModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartExportModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartFontComponent = /*#__PURE__*/(() => {
  class DxoPieChartFontComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get family() {
      return this._getOption('family');
    }
    set family(value) {
      this._setOption('family', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get weight() {
      return this._getOption('weight');
    }
    set weight(value) {
      this._setOption('weight', value);
    }
    get _optionPath() {
      return 'font';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartFontComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartFontComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartFontComponent,
      selectors: [["dxo-pie-chart-font"]],
      inputs: {
        color: "color",
        family: "family",
        opacity: "opacity",
        size: "size",
        weight: "weight"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartFontComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartFontComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartFontModule = /*#__PURE__*/(() => {
  class DxoPieChartFontModule {
    /** @nocollapse */static ɵfac = function DxoPieChartFontModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartFontModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartFontModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartFontModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartFormatComponent = /*#__PURE__*/(() => {
  class DxoPieChartFormatComponent extends NestedOption {
    get currency() {
      return this._getOption('currency');
    }
    set currency(value) {
      this._setOption('currency', value);
    }
    get formatter() {
      return this._getOption('formatter');
    }
    set formatter(value) {
      this._setOption('formatter', value);
    }
    get parser() {
      return this._getOption('parser');
    }
    set parser(value) {
      this._setOption('parser', value);
    }
    get precision() {
      return this._getOption('precision');
    }
    set precision(value) {
      this._setOption('precision', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useCurrencyAccountingStyle() {
      return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value) {
      this._setOption('useCurrencyAccountingStyle', value);
    }
    get _optionPath() {
      return 'format';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartFormatComponent,
      selectors: [["dxo-pie-chart-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartFormatComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartFormatModule = /*#__PURE__*/(() => {
  class DxoPieChartFormatModule {
    /** @nocollapse */static ɵfac = function DxoPieChartFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartHatchingComponent = /*#__PURE__*/(() => {
  class DxoPieChartHatchingComponent extends NestedOption {
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get step() {
      return this._getOption('step');
    }
    set step(value) {
      this._setOption('step', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'hatching';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartHatchingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartHatchingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartHatchingComponent,
      selectors: [["dxo-pie-chart-hatching"]],
      inputs: {
        direction: "direction",
        opacity: "opacity",
        step: "step",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartHatchingComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartHatchingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartHatchingModule = /*#__PURE__*/(() => {
  class DxoPieChartHatchingModule {
    /** @nocollapse */static ɵfac = function DxoPieChartHatchingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartHatchingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartHatchingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartHatchingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartHoverStyleComponent = /*#__PURE__*/(() => {
  class DxoPieChartHoverStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get _optionPath() {
      return 'hoverStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartHoverStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartHoverStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartHoverStyleComponent,
      selectors: [["dxo-pie-chart-hover-style"]],
      inputs: {
        border: "border",
        color: "color",
        hatching: "hatching",
        highlight: "highlight"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartHoverStyleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartHoverStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartHoverStyleModule = /*#__PURE__*/(() => {
  class DxoPieChartHoverStyleModule {
    /** @nocollapse */static ɵfac = function DxoPieChartHoverStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartHoverStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartHoverStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartHoverStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartImageComponent = /*#__PURE__*/(() => {
  class DxoPieChartImageComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get url() {
      return this._getOption('url');
    }
    set url(value) {
      this._setOption('url', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'image';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartImageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartImageComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartImageComponent,
      selectors: [["dxo-pie-chart-image"]],
      inputs: {
        height: "height",
        url: "url",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartImageComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartImageModule = /*#__PURE__*/(() => {
  class DxoPieChartImageModule {
    /** @nocollapse */static ɵfac = function DxoPieChartImageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartImageModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartImageModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartImageModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartLabelComponent = /*#__PURE__*/(() => {
  class DxoPieChartLabelComponent extends NestedOption {
    get argumentFormat() {
      return this._getOption('argumentFormat');
    }
    set argumentFormat(value) {
      this._setOption('argumentFormat', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get connector() {
      return this._getOption('connector');
    }
    set connector(value) {
      this._setOption('connector', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get displayFormat() {
      return this._getOption('displayFormat');
    }
    set displayFormat(value) {
      this._setOption('displayFormat', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get radialOffset() {
      return this._getOption('radialOffset');
    }
    set radialOffset(value) {
      this._setOption('radialOffset', value);
    }
    get rotationAngle() {
      return this._getOption('rotationAngle');
    }
    set rotationAngle(value) {
      this._setOption('rotationAngle', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartLabelComponent,
      selectors: [["dxo-pie-chart-label"]],
      inputs: {
        argumentFormat: "argumentFormat",
        backgroundColor: "backgroundColor",
        border: "border",
        connector: "connector",
        customizeText: "customizeText",
        displayFormat: "displayFormat",
        font: "font",
        format: "format",
        position: "position",
        radialOffset: "radialOffset",
        rotationAngle: "rotationAngle",
        textOverflow: "textOverflow",
        visible: "visible",
        wordWrap: "wordWrap"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartLabelComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartLabelModule = /*#__PURE__*/(() => {
  class DxoPieChartLabelModule {
    /** @nocollapse */static ɵfac = function DxoPieChartLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartLegendTitleSubtitleComponent = /*#__PURE__*/(() => {
  class DxoPieChartLegendTitleSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartLegendTitleSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartLegendTitleSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartLegendTitleSubtitleComponent,
      selectors: [["dxo-pie-chart-legend-title-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartLegendTitleSubtitleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartLegendTitleSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartLegendTitleSubtitleModule = /*#__PURE__*/(() => {
  class DxoPieChartLegendTitleSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoPieChartLegendTitleSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartLegendTitleSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartLegendTitleSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartLegendTitleSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartLegendTitleComponent = /*#__PURE__*/(() => {
  class DxoPieChartLegendTitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartLegendTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartLegendTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartLegendTitleComponent,
      selectors: [["dxo-pie-chart-legend-title"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        text: "text",
        verticalAlignment: "verticalAlignment"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartLegendTitleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartLegendTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartLegendTitleModule = /*#__PURE__*/(() => {
  class DxoPieChartLegendTitleModule {
    /** @nocollapse */static ɵfac = function DxoPieChartLegendTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartLegendTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartLegendTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartLegendTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartLegendComponent = /*#__PURE__*/(() => {
  class DxoPieChartLegendComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get columnCount() {
      return this._getOption('columnCount');
    }
    set columnCount(value) {
      this._setOption('columnCount', value);
    }
    get columnItemSpacing() {
      return this._getOption('columnItemSpacing');
    }
    set columnItemSpacing(value) {
      this._setOption('columnItemSpacing', value);
    }
    get customizeHint() {
      return this._getOption('customizeHint');
    }
    set customizeHint(value) {
      this._setOption('customizeHint', value);
    }
    get customizeItems() {
      return this._getOption('customizeItems');
    }
    set customizeItems(value) {
      this._setOption('customizeItems', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get itemsAlignment() {
      return this._getOption('itemsAlignment');
    }
    set itemsAlignment(value) {
      this._setOption('itemsAlignment', value);
    }
    get itemTextPosition() {
      return this._getOption('itemTextPosition');
    }
    set itemTextPosition(value) {
      this._setOption('itemTextPosition', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get markerSize() {
      return this._getOption('markerSize');
    }
    set markerSize(value) {
      this._setOption('markerSize', value);
    }
    get markerTemplate() {
      return this._getOption('markerTemplate');
    }
    set markerTemplate(value) {
      this._setOption('markerTemplate', value);
    }
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get rowCount() {
      return this._getOption('rowCount');
    }
    set rowCount(value) {
      this._setOption('rowCount', value);
    }
    get rowItemSpacing() {
      return this._getOption('rowItemSpacing');
    }
    set rowItemSpacing(value) {
      this._setOption('rowItemSpacing', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'legend';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartLegendComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartLegendComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartLegendComponent,
      selectors: [["dxo-pie-chart-legend"]],
      inputs: {
        backgroundColor: "backgroundColor",
        border: "border",
        columnCount: "columnCount",
        columnItemSpacing: "columnItemSpacing",
        customizeHint: "customizeHint",
        customizeItems: "customizeItems",
        customizeText: "customizeText",
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        hoverMode: "hoverMode",
        itemsAlignment: "itemsAlignment",
        itemTextPosition: "itemTextPosition",
        margin: "margin",
        markerSize: "markerSize",
        markerTemplate: "markerTemplate",
        orientation: "orientation",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        rowCount: "rowCount",
        rowItemSpacing: "rowItemSpacing",
        title: "title",
        verticalAlignment: "verticalAlignment",
        visible: "visible"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartLegendComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartLegendComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartLegendModule = /*#__PURE__*/(() => {
  class DxoPieChartLegendModule {
    /** @nocollapse */static ɵfac = function DxoPieChartLegendModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartLegendModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartLegendModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartLegendModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartLoadingIndicatorComponent = /*#__PURE__*/(() => {
  class DxoPieChartLoadingIndicatorComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    showChange;
    get _optionPath() {
      return 'loadingIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'showChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartLoadingIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartLoadingIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartLoadingIndicatorComponent,
      selectors: [["dxo-pie-chart-loading-indicator"]],
      inputs: {
        backgroundColor: "backgroundColor",
        enabled: "enabled",
        font: "font",
        show: "show",
        text: "text"
      },
      outputs: {
        showChange: "showChange"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartLoadingIndicatorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartLoadingIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartLoadingIndicatorModule = /*#__PURE__*/(() => {
  class DxoPieChartLoadingIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoPieChartLoadingIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartLoadingIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartLoadingIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartLoadingIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartMarginComponent = /*#__PURE__*/(() => {
  class DxoPieChartMarginComponent extends NestedOption {
    get bottom() {
      return this._getOption('bottom');
    }
    set bottom(value) {
      this._setOption('bottom', value);
    }
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get right() {
      return this._getOption('right');
    }
    set right(value) {
      this._setOption('right', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'margin';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartMarginComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartMarginComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartMarginComponent,
      selectors: [["dxo-pie-chart-margin"]],
      inputs: {
        bottom: "bottom",
        left: "left",
        right: "right",
        top: "top"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartMarginComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartMarginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartMarginModule = /*#__PURE__*/(() => {
  class DxoPieChartMarginModule {
    /** @nocollapse */static ɵfac = function DxoPieChartMarginModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartMarginModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartMarginModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartMarginModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartPieChartTitleSubtitleComponent = /*#__PURE__*/(() => {
  class DxoPieChartPieChartTitleSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartPieChartTitleSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartPieChartTitleSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartPieChartTitleSubtitleComponent,
      selectors: [["dxo-pie-chart-pie-chart-title-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartPieChartTitleSubtitleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartPieChartTitleSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartPieChartTitleSubtitleModule = /*#__PURE__*/(() => {
  class DxoPieChartPieChartTitleSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoPieChartPieChartTitleSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartPieChartTitleSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartPieChartTitleSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartPieChartTitleSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartPieChartTitleComponent = /*#__PURE__*/(() => {
  class DxoPieChartPieChartTitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartPieChartTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartPieChartTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartPieChartTitleComponent,
      selectors: [["dxo-pie-chart-pie-chart-title"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        text: "text",
        textOverflow: "textOverflow",
        verticalAlignment: "verticalAlignment",
        wordWrap: "wordWrap"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartPieChartTitleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartPieChartTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartPieChartTitleModule = /*#__PURE__*/(() => {
  class DxoPieChartPieChartTitleModule {
    /** @nocollapse */static ɵfac = function DxoPieChartPieChartTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartPieChartTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartPieChartTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartPieChartTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartSelectionStyleComponent = /*#__PURE__*/(() => {
  class DxoPieChartSelectionStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get _optionPath() {
      return 'selectionStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartSelectionStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSelectionStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartSelectionStyleComponent,
      selectors: [["dxo-pie-chart-selection-style"]],
      inputs: {
        border: "border",
        color: "color",
        hatching: "hatching",
        highlight: "highlight"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartSelectionStyleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartSelectionStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartSelectionStyleModule = /*#__PURE__*/(() => {
  class DxoPieChartSelectionStyleModule {
    /** @nocollapse */static ɵfac = function DxoPieChartSelectionStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSelectionStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartSelectionStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartSelectionStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartSeriesBorderComponent = /*#__PURE__*/(() => {
  class DxoPieChartSeriesBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartSeriesBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSeriesBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartSeriesBorderComponent,
      selectors: [["dxo-pie-chart-series-border"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartSeriesBorderComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartSeriesBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartSeriesBorderModule = /*#__PURE__*/(() => {
  class DxoPieChartSeriesBorderModule {
    /** @nocollapse */static ɵfac = function DxoPieChartSeriesBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSeriesBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartSeriesBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartSeriesBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiPieChartSeriesComponent = /*#__PURE__*/(() => {
  class DxiPieChartSeriesComponent extends CollectionNestedOption {
    get argumentField() {
      return this._getOption('argumentField');
    }
    set argumentField(value) {
      this._setOption('argumentField', value);
    }
    get argumentType() {
      return this._getOption('argumentType');
    }
    set argumentType(value) {
      this._setOption('argumentType', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get maxLabelCount() {
      return this._getOption('maxLabelCount');
    }
    set maxLabelCount(value) {
      this._setOption('maxLabelCount', value);
    }
    get minSegmentSize() {
      return this._getOption('minSegmentSize');
    }
    set minSegmentSize(value) {
      this._setOption('minSegmentSize', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get smallValuesGrouping() {
      return this._getOption('smallValuesGrouping');
    }
    set smallValuesGrouping(value) {
      this._setOption('smallValuesGrouping', value);
    }
    get tag() {
      return this._getOption('tag');
    }
    set tag(value) {
      this._setOption('tag', value);
    }
    get tagField() {
      return this._getOption('tagField');
    }
    set tagField(value) {
      this._setOption('tagField', value);
    }
    get valueField() {
      return this._getOption('valueField');
    }
    set valueField(value) {
      this._setOption('valueField', value);
    }
    get _optionPath() {
      return 'series';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiPieChartSeriesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPieChartSeriesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiPieChartSeriesComponent,
      selectors: [["dxi-pie-chart-series"]],
      inputs: {
        argumentField: "argumentField",
        argumentType: "argumentType",
        border: "border",
        color: "color",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        label: "label",
        maxLabelCount: "maxLabelCount",
        minSegmentSize: "minSegmentSize",
        name: "name",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        smallValuesGrouping: "smallValuesGrouping",
        tag: "tag",
        tagField: "tagField",
        valueField: "valueField"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiPieChartSeriesComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiPieChartSeriesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiPieChartSeriesModule = /*#__PURE__*/(() => {
  class DxiPieChartSeriesModule {
    /** @nocollapse */static ɵfac = function DxiPieChartSeriesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPieChartSeriesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiPieChartSeriesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiPieChartSeriesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartSeriesTemplateComponent = /*#__PURE__*/(() => {
  class DxoPieChartSeriesTemplateComponent extends NestedOption {
    get customizeSeries() {
      return this._getOption('customizeSeries');
    }
    set customizeSeries(value) {
      this._setOption('customizeSeries', value);
    }
    get nameField() {
      return this._getOption('nameField');
    }
    set nameField(value) {
      this._setOption('nameField', value);
    }
    get _optionPath() {
      return 'seriesTemplate';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartSeriesTemplateComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSeriesTemplateComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartSeriesTemplateComponent,
      selectors: [["dxo-pie-chart-series-template"]],
      inputs: {
        customizeSeries: "customizeSeries",
        nameField: "nameField"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartSeriesTemplateComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartSeriesTemplateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartSeriesTemplateModule = /*#__PURE__*/(() => {
  class DxoPieChartSeriesTemplateModule {
    /** @nocollapse */static ɵfac = function DxoPieChartSeriesTemplateModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSeriesTemplateModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartSeriesTemplateModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartSeriesTemplateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartShadowComponent = /*#__PURE__*/(() => {
  class DxoPieChartShadowComponent extends NestedOption {
    get blur() {
      return this._getOption('blur');
    }
    set blur(value) {
      this._setOption('blur', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'shadow';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartShadowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartShadowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartShadowComponent,
      selectors: [["dxo-pie-chart-shadow"]],
      inputs: {
        blur: "blur",
        color: "color",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartShadowComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartShadowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartShadowModule = /*#__PURE__*/(() => {
  class DxoPieChartShadowModule {
    /** @nocollapse */static ɵfac = function DxoPieChartShadowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartShadowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartShadowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartShadowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartSizeComponent = /*#__PURE__*/(() => {
  class DxoPieChartSizeComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'size';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartSizeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSizeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartSizeComponent,
      selectors: [["dxo-pie-chart-size"]],
      inputs: {
        height: "height",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartSizeComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartSizeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartSizeModule = /*#__PURE__*/(() => {
  class DxoPieChartSizeModule {
    /** @nocollapse */static ɵfac = function DxoPieChartSizeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSizeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartSizeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartSizeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartSmallValuesGroupingComponent = /*#__PURE__*/(() => {
  class DxoPieChartSmallValuesGroupingComponent extends NestedOption {
    get groupName() {
      return this._getOption('groupName');
    }
    set groupName(value) {
      this._setOption('groupName', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get threshold() {
      return this._getOption('threshold');
    }
    set threshold(value) {
      this._setOption('threshold', value);
    }
    get topCount() {
      return this._getOption('topCount');
    }
    set topCount(value) {
      this._setOption('topCount', value);
    }
    get _optionPath() {
      return 'smallValuesGrouping';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartSmallValuesGroupingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSmallValuesGroupingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartSmallValuesGroupingComponent,
      selectors: [["dxo-pie-chart-small-values-grouping"]],
      inputs: {
        groupName: "groupName",
        mode: "mode",
        threshold: "threshold",
        topCount: "topCount"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartSmallValuesGroupingComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartSmallValuesGroupingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartSmallValuesGroupingModule = /*#__PURE__*/(() => {
  class DxoPieChartSmallValuesGroupingModule {
    /** @nocollapse */static ɵfac = function DxoPieChartSmallValuesGroupingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSmallValuesGroupingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartSmallValuesGroupingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartSmallValuesGroupingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartSubtitleComponent = /*#__PURE__*/(() => {
  class DxoPieChartSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartSubtitleComponent,
      selectors: [["dxo-pie-chart-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartSubtitleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartSubtitleModule = /*#__PURE__*/(() => {
  class DxoPieChartSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoPieChartSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartTitleComponent = /*#__PURE__*/(() => {
  class DxoPieChartTitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartTitleComponent,
      selectors: [["dxo-pie-chart-title"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        text: "text",
        verticalAlignment: "verticalAlignment",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartTitleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartTitleModule = /*#__PURE__*/(() => {
  class DxoPieChartTitleModule {
    /** @nocollapse */static ɵfac = function DxoPieChartTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartTooltipBorderComponent = /*#__PURE__*/(() => {
  class DxoPieChartTooltipBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartTooltipBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartTooltipBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartTooltipBorderComponent,
      selectors: [["dxo-pie-chart-tooltip-border"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartTooltipBorderComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartTooltipBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartTooltipBorderModule = /*#__PURE__*/(() => {
  class DxoPieChartTooltipBorderModule {
    /** @nocollapse */static ɵfac = function DxoPieChartTooltipBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartTooltipBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartTooltipBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartTooltipBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPieChartTooltipComponent = /*#__PURE__*/(() => {
  class DxoPieChartTooltipComponent extends NestedOption {
    get argumentFormat() {
      return this._getOption('argumentFormat');
    }
    set argumentFormat(value) {
      this._setOption('argumentFormat', value);
    }
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get interactive() {
      return this._getOption('interactive');
    }
    set interactive(value) {
      this._setOption('interactive', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get shared() {
      return this._getOption('shared');
    }
    set shared(value) {
      this._setOption('shared', value);
    }
    get zIndex() {
      return this._getOption('zIndex');
    }
    set zIndex(value) {
      this._setOption('zIndex', value);
    }
    get _optionPath() {
      return 'tooltip';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPieChartTooltipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartTooltipComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPieChartTooltipComponent,
      selectors: [["dxo-pie-chart-tooltip"]],
      inputs: {
        argumentFormat: "argumentFormat",
        arrowLength: "arrowLength",
        border: "border",
        color: "color",
        container: "container",
        contentTemplate: "contentTemplate",
        cornerRadius: "cornerRadius",
        customizeTooltip: "customizeTooltip",
        enabled: "enabled",
        font: "font",
        format: "format",
        interactive: "interactive",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        shadow: "shadow",
        shared: "shared",
        zIndex: "zIndex"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPieChartTooltipComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPieChartTooltipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPieChartTooltipModule = /*#__PURE__*/(() => {
  class DxoPieChartTooltipModule {
    /** @nocollapse */static ɵfac = function DxoPieChartTooltipModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPieChartTooltipModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPieChartTooltipModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoPieChartTooltipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiPieChartAnnotationComponent, DxiPieChartAnnotationModule, DxiPieChartSeriesComponent, DxiPieChartSeriesModule, DxoPieChartAdaptiveLayoutComponent, DxoPieChartAdaptiveLayoutModule, DxoPieChartAnimationComponent, DxoPieChartAnimationModule, DxoPieChartAnnotationBorderComponent, DxoPieChartAnnotationBorderModule, DxoPieChartArgumentFormatComponent, DxoPieChartArgumentFormatModule, DxoPieChartBorderComponent, DxoPieChartBorderModule, DxoPieChartColorComponent, DxoPieChartColorModule, DxoPieChartCommonAnnotationSettingsComponent, DxoPieChartCommonAnnotationSettingsModule, DxoPieChartCommonSeriesSettingsComponent, DxoPieChartCommonSeriesSettingsModule, DxoPieChartConnectorComponent, DxoPieChartConnectorModule, DxoPieChartExportComponent, DxoPieChartExportModule, DxoPieChartFontComponent, DxoPieChartFontModule, DxoPieChartFormatComponent, DxoPieChartFormatModule, DxoPieChartHatchingComponent, DxoPieChartHatchingModule, DxoPieChartHoverStyleComponent, DxoPieChartHoverStyleModule, DxoPieChartImageComponent, DxoPieChartImageModule, DxoPieChartLabelComponent, DxoPieChartLabelModule, DxoPieChartLegendComponent, DxoPieChartLegendModule, DxoPieChartLegendTitleComponent, DxoPieChartLegendTitleModule, DxoPieChartLegendTitleSubtitleComponent, DxoPieChartLegendTitleSubtitleModule, DxoPieChartLoadingIndicatorComponent, DxoPieChartLoadingIndicatorModule, DxoPieChartMarginComponent, DxoPieChartMarginModule, DxoPieChartPieChartTitleComponent, DxoPieChartPieChartTitleModule, DxoPieChartPieChartTitleSubtitleComponent, DxoPieChartPieChartTitleSubtitleModule, DxoPieChartSelectionStyleComponent, DxoPieChartSelectionStyleModule, DxoPieChartSeriesBorderComponent, DxoPieChartSeriesBorderModule, DxoPieChartSeriesTemplateComponent, DxoPieChartSeriesTemplateModule, DxoPieChartShadowComponent, DxoPieChartShadowModule, DxoPieChartSizeComponent, DxoPieChartSizeModule, DxoPieChartSmallValuesGroupingComponent, DxoPieChartSmallValuesGroupingModule, DxoPieChartSubtitleComponent, DxoPieChartSubtitleModule, DxoPieChartTitleComponent, DxoPieChartTitleModule, DxoPieChartTooltipBorderComponent, DxoPieChartTooltipBorderModule, DxoPieChartTooltipComponent, DxoPieChartTooltipModule };
